// extracted by mini-css-extract-plugin
export default {"UpdateMinesProviderConfigModalDialog":"UpdateMinesProviderConfigModalDialog_UpdateMinesProviderConfigModalDialog__DhTlK"};